import ErrorManager from '@/common/utils/ErrorManager';
import { Estimate } from '@/models/Estimate';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { EstimateRequestState } from '.';
import EstimateService from '../services/EstimateService';
import { EstimateModuleAction, EstimateModuleActionTypes } from './actions-types';
import { ESTIMATE } from './mutation-types';
import { EstimateModification } from '@/models/EstimateModification';

export const actions: ActionTree<EstimateRequestState, RootState> = {
    async [EstimateModuleAction.SEND_ASK_ESTIMATE]({ state, commit }: EstimateModuleActionTypes): Promise<void> {
        commit(ESTIMATE.SET_LOADING, true);
        const newEstimate: Estimate = {
            objet: state.objet,
            description: state.descriptif,
            delai: state.date,
            chantierId: state.site?.chantierId as number,
            siteId: state.site?.id as number,
            origineDemande: 'PORTAIL'
        };
        try {
            await EstimateService.sendAskEstimate(newEstimate, state.documents)
                .then(async res => {
                    commit(ESTIMATE.SET_RESPONSE, res.data);
                    commit(ESTIMATE.SET_SUCCESS, true);
                    commit(ESTIMATE.SET_ERROR, undefined);
                });
        } catch (error) {
            commit(ESTIMATE.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
        commit(ESTIMATE.SET_LOADING, false);
    },
    async [EstimateModuleAction.UPDATE_ASK_ESTIMATE]({ state, commit }: EstimateModuleActionTypes): Promise<void> {
        commit(ESTIMATE.SET_LOADING, true);
        const updatedEstimate: EstimateModification = {
            objet: state.objet,
            description: state.descriptif,
            delai: state.date,
        };

        try {
            await EstimateService.updateAskEstimate(state.editingEstimateId as number, updatedEstimate, state.documents).then(async res => {
            commit(ESTIMATE.SET_RESPONSE, res.data);
            commit(ESTIMATE.SET_SUCCESS, true);
            commit(ESTIMATE.SET_ERROR, undefined);
                commit('demandeDevisModuleState/UPDATE_OBJET', {
                    id: state.editingEstimateId,
                    objet: state.objet
                }, { root: true });
            });
        } catch (error) {
            commit(ESTIMATE.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }

        commit(ESTIMATE.SET_LOADING, false);
    },
};
